export const PRIVACY_POLICY = '/page/privacy-policy';
export const TERMS_AND_CONDITIONS = '/page/terms-conditions';
export const DEFAULT_COUNTRY = 231;
